export type ThemeVariant = 'bingo-light' | 'spins-light' | 'combo-light' | 'bingo-dark' | 'spins-dark' | 'combo-dark';

export type NavigationItem = {
  translations?: Array<{
    slug: string;
    title: string;
  } | null>;
};

export type ProcessedNavItem = {
  slug: string;
  title: string;
};

export const navLinks = [
  { label: 'Bingo', href: '#bingo' },
  { label: 'Jackpots', href: '#jackpots' },
  { label: 'Slingo & Instant Games', href: '#slingo' },
  { label: 'Exclusive Content', href: '#exclusive' },
  { label: 'Game Shows', href: '#shows' },
  { label: 'Missions', href: '#missions' },
];

export const comboHeroCtas = [
  { id: 'bingo' as const, label: 'SIGN UP FOR BINGO' },
  { id: 'spins' as const, label: 'SIGN UP FOR SPINS' },
];

export const STEP_OR_SEPARATOR = /\sOR\s/;
